import { useCallback, useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { fetchMissingRequiredDocumentsByEmployee } from '../../utils/cvDocuments';

/**
 * Active employees missing any required CV/GCP/IATA document — the same rule
 * the SMO Lead reports use (utils/cvDocuments). Returns rows sorted by name:
 * `{ employee, missing: [{ key, label }, ...] }`.
 */
const useMissingEmployeeDocuments = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // `Active` is stored as 1 on most records but '1' on some older imports.
      const snapshot = await getDocs(
        query(collection(db, 'Employees'), where('Active', 'in', [1, '1']))
      );
      const employees = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      const missingById = await fetchMissingRequiredDocumentsByEmployee(employees.map(e => e.id));

      const result = employees
        .filter(emp => missingById[emp.id]?.length > 0)
        .map(emp => ({ employee: emp, missing: missingById[emp.id] }))
        .sort((a, b) =>
          `${a.employee.eName || ''} ${a.employee.eSurname || ''}`
            .localeCompare(`${b.employee.eName || ''} ${b.employee.eSurname || ''}`, 'tr')
        );
      setRows(result);
    } catch (err) {
      console.error('Eksik belgeler yüklenemedi:', err);
      setError('Eksik belgeler yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { rows, loading, error, reload: load };
};

export default useMissingEmployeeDocuments;
